"use strict";

exports.__esModule = true;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_NONE = exports.SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT = exports.SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT = exports.isAuthorImageSupported = exports.isMultiplePagesSupported = exports.isLayoutNameTextOnImage = exports.isLayoutNameList = exports.isLayoutNameSlider = exports.isLayoutNameGrid = exports.isLayoutNamePGOneColumn = exports.isLayoutNamePGSideBySide = exports.isLayoutNameMobile = exports.isLayoutMobile = exports.isLayoutList = exports.isLayoutSlider = exports.isLayoutTextOnImage = exports.isLayoutFullPost = exports.isLayoutGrid = exports.isLayoutPGWithContentHeight = exports.isLayoutPGCardMedium = exports.isLayoutPGSideBySide = exports.isLayoutPGGrid = exports.isLayoutPGOneColumn = exports.isLayoutNameOneOfProGallery = exports.isPGLayoutWithDescription = exports.isLayoutProGallery = exports.getLayoutName = exports.OTHER_LAYOUT_TYPES = exports.LAYOUT_TYPES_MOBILE = exports.getLayoutTypeById = exports.LAYOUT_TYPES = exports.POST_LIST_LAYOUT_TYPES = exports.FEED_LAYOUT_TYPES = exports.MOBILE_LAYOUT_NAMES = exports.LAYOUT_NAME_LIST = exports.LAYOUT_NAME_SLIDER = exports.LAYOUT_NAME_PG_ONE_COLUMN = exports.LAYOUT_NAME_PG_GRID = exports.LAYOUT_NAME_PG_SIDE_BY_SIDE = exports.LAYOUT_NAME_PG_CARD_MEDIUM = exports.LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = exports.LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = exports.LAYOUT_NAME_ONE_COLUMN_MOBILE = exports.LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = exports.LAYOUT_NAME_GRID = exports.LAYOUT_NAME_SIDE_BY_SIDE = exports.LAYOUT_NAME_MOBILE = exports.LAYOUT_NAME_FULL_POST = exports.LAYOUT_NAME_CARD_PROFILE = exports.LAYOUT_NAME_CARD_LARGE = exports.LAYOUT_NAME_CARD_MEDIUM = exports.LAYOUT_NAME_CARD_SMALL = exports.SEO_LAYOUT_TYPE_FALLBACK = exports.getLayoutPaginationTypeNameById = exports.PAGINATION_TYPE_NAME_BY_ID = exports.PAGINATION_TYPE_WITH_PAGE_NUMBERS = exports.PAGINATION_TYPE_ON_SCROLL_DOWN = exports.getLayoutNameById = exports.LAYOUT_NAMES_BY_ID = exports.getPGMappedLayout = exports.LAYOUT_LIST = exports.LAYOUT_SLIDER = exports.LAYOUT_PG_ONE_COLUMN = exports.LAYOUT_PG_GRID = exports.LAYOUT_PG_SIDE_BY_SIDE = exports.LAYOUT_PG_CARD_MEDIUM = exports.LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_TEXT_ON_IMAGE_MOBILE = exports.LAYOUT_SIDE_BY_SIDE_MOBILE = exports.LAYOUT_ONE_COLUMN_MOBILE = exports.LAYOUT_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_TEXT_ON_IMAGE_SMALL = exports.LAYOUT_GRID = exports.LAYOUT_SIDE_BY_SIDE = exports.LAYOUT_MOBILE = exports.LAYOUT_FULL_POST = exports.LAYOUT_CARD_PROFILE = exports.LAYOUT_CARD_LARGE = exports.LAYOUT_CARD_MEDIUM = exports.LAYOUT_CARD_SMALL = void 0;

var _lodash = require("lodash");

var _OLD_LAYOUT_PG_MAP, _LAYOUT_NAMES_BY_ID, _PAGINATION_TYPE_NAME, _FEED_LAYOUT_TYPES, _POST_LIST_LAYOUT_TYP, _LAYOUT_TYPES_MOBILE, _OTHER_LAYOUT_TYPES;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LAYOUT_CARD_SMALL = 0;
exports.LAYOUT_CARD_SMALL = LAYOUT_CARD_SMALL;
var LAYOUT_CARD_MEDIUM = 1;
exports.LAYOUT_CARD_MEDIUM = LAYOUT_CARD_MEDIUM;
var LAYOUT_CARD_LARGE = 2;
exports.LAYOUT_CARD_LARGE = LAYOUT_CARD_LARGE;
var LAYOUT_CARD_PROFILE = 3;
exports.LAYOUT_CARD_PROFILE = LAYOUT_CARD_PROFILE;
var LAYOUT_FULL_POST = 4;
exports.LAYOUT_FULL_POST = LAYOUT_FULL_POST;
var LAYOUT_MOBILE = 5;
exports.LAYOUT_MOBILE = LAYOUT_MOBILE;
var LAYOUT_SIDE_BY_SIDE = 6;
exports.LAYOUT_SIDE_BY_SIDE = LAYOUT_SIDE_BY_SIDE;
var LAYOUT_GRID = 7;
exports.LAYOUT_GRID = LAYOUT_GRID;
var LAYOUT_TEXT_ON_IMAGE_SMALL = 8;
exports.LAYOUT_TEXT_ON_IMAGE_SMALL = LAYOUT_TEXT_ON_IMAGE_SMALL;
var LAYOUT_TEXT_ON_IMAGE_MEDIUM = 9;
exports.LAYOUT_TEXT_ON_IMAGE_MEDIUM = LAYOUT_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_ONE_COLUMN_MOBILE = 10;
exports.LAYOUT_ONE_COLUMN_MOBILE = LAYOUT_ONE_COLUMN_MOBILE;
var LAYOUT_SIDE_BY_SIDE_MOBILE = 11;
exports.LAYOUT_SIDE_BY_SIDE_MOBILE = LAYOUT_SIDE_BY_SIDE_MOBILE;
var LAYOUT_TEXT_ON_IMAGE_MOBILE = 12;
exports.LAYOUT_TEXT_ON_IMAGE_MOBILE = LAYOUT_TEXT_ON_IMAGE_MOBILE;
var LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = 13;
exports.LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_PG_CARD_MEDIUM = 14;
exports.LAYOUT_PG_CARD_MEDIUM = LAYOUT_PG_CARD_MEDIUM;
var LAYOUT_PG_SIDE_BY_SIDE = 15;
exports.LAYOUT_PG_SIDE_BY_SIDE = LAYOUT_PG_SIDE_BY_SIDE;
var LAYOUT_PG_GRID = 16;
exports.LAYOUT_PG_GRID = LAYOUT_PG_GRID;
var LAYOUT_PG_ONE_COLUMN = 17;
exports.LAYOUT_PG_ONE_COLUMN = LAYOUT_PG_ONE_COLUMN;
var LAYOUT_SLIDER = 18;
exports.LAYOUT_SLIDER = LAYOUT_SLIDER;
var LAYOUT_LIST = 19;
exports.LAYOUT_LIST = LAYOUT_LIST;
var OLD_LAYOUT_PG_MAP = (_OLD_LAYOUT_PG_MAP = {}, _OLD_LAYOUT_PG_MAP[LAYOUT_CARD_MEDIUM] = LAYOUT_PG_CARD_MEDIUM, _OLD_LAYOUT_PG_MAP[LAYOUT_SIDE_BY_SIDE] = LAYOUT_PG_SIDE_BY_SIDE, _OLD_LAYOUT_PG_MAP[LAYOUT_TEXT_ON_IMAGE_MEDIUM] = LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, _OLD_LAYOUT_PG_MAP[LAYOUT_GRID] = LAYOUT_PG_GRID, _OLD_LAYOUT_PG_MAP[LAYOUT_CARD_SMALL] = LAYOUT_PG_CARD_MEDIUM, _OLD_LAYOUT_PG_MAP[LAYOUT_TEXT_ON_IMAGE_SMALL] = LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, _OLD_LAYOUT_PG_MAP[LAYOUT_CARD_LARGE] = LAYOUT_PG_GRID, _OLD_LAYOUT_PG_MAP);

var getPGMappedLayout = function getPGMappedLayout(layoutType, isOneColumnPGLayoutEnabled) {
  if (isOneColumnPGLayoutEnabled && isLayoutOneColumn(layoutType)) {
    return LAYOUT_PG_ONE_COLUMN;
  }

  return OLD_LAYOUT_PG_MAP[layoutType] || layoutType;
};

exports.getPGMappedLayout = getPGMappedLayout;
var LAYOUT_NAMES_BY_ID = (_LAYOUT_NAMES_BY_ID = {}, _LAYOUT_NAMES_BY_ID[LAYOUT_CARD_SMALL] = 'Brick', _LAYOUT_NAMES_BY_ID[LAYOUT_CARD_MEDIUM] = 'Tiled', _LAYOUT_NAMES_BY_ID[LAYOUT_CARD_LARGE] = 'One column', _LAYOUT_NAMES_BY_ID[LAYOUT_FULL_POST] = 'Full post', _LAYOUT_NAMES_BY_ID[LAYOUT_SIDE_BY_SIDE] = 'Side by side', _LAYOUT_NAMES_BY_ID[LAYOUT_GRID] = 'Editorial', _LAYOUT_NAMES_BY_ID[LAYOUT_TEXT_ON_IMAGE_SMALL] = 'Postcard', _LAYOUT_NAMES_BY_ID[LAYOUT_TEXT_ON_IMAGE_MEDIUM] = 'Magazine', _LAYOUT_NAMES_BY_ID[LAYOUT_ONE_COLUMN_MOBILE] = 'Mobile One Column', _LAYOUT_NAMES_BY_ID[LAYOUT_SIDE_BY_SIDE_MOBILE] = 'Mobile Side By Side', _LAYOUT_NAMES_BY_ID[LAYOUT_TEXT_ON_IMAGE_MOBILE] = 'Mobile Magazine', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM] = 'Magazine Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_CARD_MEDIUM] = 'Tiled Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_SIDE_BY_SIDE] = 'Side by side Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_GRID] = 'Editorial Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_ONE_COLUMN] = 'One column Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_SLIDER] = 'Slider', _LAYOUT_NAMES_BY_ID[LAYOUT_LIST] = 'List', _LAYOUT_NAMES_BY_ID);
exports.LAYOUT_NAMES_BY_ID = LAYOUT_NAMES_BY_ID;

var getLayoutNameById = function getLayoutNameById(layoutId) {
  return LAYOUT_NAMES_BY_ID[layoutId];
};

exports.getLayoutNameById = getLayoutNameById;
var PAGINATION_TYPE_ON_SCROLL_DOWN = 0;
exports.PAGINATION_TYPE_ON_SCROLL_DOWN = PAGINATION_TYPE_ON_SCROLL_DOWN;
var PAGINATION_TYPE_WITH_PAGE_NUMBERS = 1;
exports.PAGINATION_TYPE_WITH_PAGE_NUMBERS = PAGINATION_TYPE_WITH_PAGE_NUMBERS;
var PAGINATION_TYPE_NAME_BY_ID = (_PAGINATION_TYPE_NAME = {}, _PAGINATION_TYPE_NAME[PAGINATION_TYPE_ON_SCROLL_DOWN] = 'On scroll down', _PAGINATION_TYPE_NAME[PAGINATION_TYPE_WITH_PAGE_NUMBERS] = 'With page numbers', _PAGINATION_TYPE_NAME);
exports.PAGINATION_TYPE_NAME_BY_ID = PAGINATION_TYPE_NAME_BY_ID;

var getLayoutPaginationTypeNameById = function getLayoutPaginationTypeNameById(typeId) {
  return PAGINATION_TYPE_NAME_BY_ID[typeId];
};

exports.getLayoutPaginationTypeNameById = getLayoutPaginationTypeNameById;
var SEO_LAYOUT_TYPE_FALLBACK = LAYOUT_GRID;
exports.SEO_LAYOUT_TYPE_FALLBACK = SEO_LAYOUT_TYPE_FALLBACK;
var LAYOUT_NAME_CARD_SMALL = 'small';
exports.LAYOUT_NAME_CARD_SMALL = LAYOUT_NAME_CARD_SMALL;
var LAYOUT_NAME_CARD_MEDIUM = 'medium';
exports.LAYOUT_NAME_CARD_MEDIUM = LAYOUT_NAME_CARD_MEDIUM;
var LAYOUT_NAME_CARD_LARGE = 'large';
exports.LAYOUT_NAME_CARD_LARGE = LAYOUT_NAME_CARD_LARGE;
var LAYOUT_NAME_CARD_PROFILE = 'profile';
exports.LAYOUT_NAME_CARD_PROFILE = LAYOUT_NAME_CARD_PROFILE;
var LAYOUT_NAME_FULL_POST = 'full';
exports.LAYOUT_NAME_FULL_POST = LAYOUT_NAME_FULL_POST;
var LAYOUT_NAME_MOBILE = 'mobile';
exports.LAYOUT_NAME_MOBILE = LAYOUT_NAME_MOBILE;
var LAYOUT_NAME_SIDE_BY_SIDE = 'side-by-side';
exports.LAYOUT_NAME_SIDE_BY_SIDE = LAYOUT_NAME_SIDE_BY_SIDE;
var LAYOUT_NAME_GRID = 'grid';
exports.LAYOUT_NAME_GRID = LAYOUT_NAME_GRID;
var LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = 'text-on-image-small';
exports.LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = LAYOUT_NAME_TEXT_ON_IMAGE_SMALL;
var LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = 'text-on-image-medium';
exports.LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_NAME_ONE_COLUMN_MOBILE = 'one-column-mobile';
exports.LAYOUT_NAME_ONE_COLUMN_MOBILE = LAYOUT_NAME_ONE_COLUMN_MOBILE;
var LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = 'side-by-side-mobile';
exports.LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = LAYOUT_NAME_SIDE_BY_SIDE_MOBILE;
var LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = 'text-on-image-mobile';
exports.LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE;
var LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = 'pg-text-on-image-medium';
exports.LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_NAME_PG_CARD_MEDIUM = 'pg-medium';
exports.LAYOUT_NAME_PG_CARD_MEDIUM = LAYOUT_NAME_PG_CARD_MEDIUM;
var LAYOUT_NAME_PG_SIDE_BY_SIDE = 'pg-side-by-side';
exports.LAYOUT_NAME_PG_SIDE_BY_SIDE = LAYOUT_NAME_PG_SIDE_BY_SIDE;
var LAYOUT_NAME_PG_GRID = 'pg-grid';
exports.LAYOUT_NAME_PG_GRID = LAYOUT_NAME_PG_GRID;
var LAYOUT_NAME_PG_ONE_COLUMN = 'pg-one-column';
exports.LAYOUT_NAME_PG_ONE_COLUMN = LAYOUT_NAME_PG_ONE_COLUMN;
var LAYOUT_NAME_SLIDER = 'slider';
exports.LAYOUT_NAME_SLIDER = LAYOUT_NAME_SLIDER;
var LAYOUT_NAME_LIST = 'list';
exports.LAYOUT_NAME_LIST = LAYOUT_NAME_LIST;
var MOBILE_LAYOUT_NAMES = [LAYOUT_NAME_MOBILE, LAYOUT_NAME_ONE_COLUMN_MOBILE, LAYOUT_NAME_SIDE_BY_SIDE_MOBILE, LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE];
exports.MOBILE_LAYOUT_NAMES = MOBILE_LAYOUT_NAMES;
var FEED_LAYOUT_TYPES = (_FEED_LAYOUT_TYPES = {}, _FEED_LAYOUT_TYPES[LAYOUT_CARD_SMALL] = LAYOUT_NAME_CARD_SMALL, _FEED_LAYOUT_TYPES[LAYOUT_CARD_MEDIUM] = LAYOUT_NAME_CARD_MEDIUM, _FEED_LAYOUT_TYPES[LAYOUT_CARD_LARGE] = LAYOUT_NAME_CARD_LARGE, _FEED_LAYOUT_TYPES[LAYOUT_FULL_POST] = LAYOUT_NAME_FULL_POST, _FEED_LAYOUT_TYPES[LAYOUT_SIDE_BY_SIDE] = LAYOUT_NAME_SIDE_BY_SIDE, _FEED_LAYOUT_TYPES[LAYOUT_GRID] = LAYOUT_NAME_GRID, _FEED_LAYOUT_TYPES[LAYOUT_TEXT_ON_IMAGE_SMALL] = LAYOUT_NAME_TEXT_ON_IMAGE_SMALL, _FEED_LAYOUT_TYPES[LAYOUT_TEXT_ON_IMAGE_MEDIUM] = LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM, _FEED_LAYOUT_TYPES[LAYOUT_TEXT_ON_IMAGE_MOBILE] = LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE, _FEED_LAYOUT_TYPES[LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM] = LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM, _FEED_LAYOUT_TYPES[LAYOUT_PG_CARD_MEDIUM] = LAYOUT_NAME_PG_CARD_MEDIUM, _FEED_LAYOUT_TYPES[LAYOUT_PG_SIDE_BY_SIDE] = LAYOUT_NAME_PG_SIDE_BY_SIDE, _FEED_LAYOUT_TYPES[LAYOUT_PG_GRID] = LAYOUT_NAME_PG_GRID, _FEED_LAYOUT_TYPES[LAYOUT_PG_ONE_COLUMN] = LAYOUT_NAME_PG_ONE_COLUMN, _FEED_LAYOUT_TYPES);
exports.FEED_LAYOUT_TYPES = FEED_LAYOUT_TYPES;
var POST_LIST_LAYOUT_TYPES = (_POST_LIST_LAYOUT_TYP = {}, _POST_LIST_LAYOUT_TYP[LAYOUT_PG_GRID] = LAYOUT_NAME_PG_GRID, _POST_LIST_LAYOUT_TYP[LAYOUT_SLIDER] = LAYOUT_NAME_SLIDER, _POST_LIST_LAYOUT_TYP[LAYOUT_LIST] = LAYOUT_NAME_LIST, _POST_LIST_LAYOUT_TYP[LAYOUT_PG_SIDE_BY_SIDE] = LAYOUT_NAME_PG_SIDE_BY_SIDE, _POST_LIST_LAYOUT_TYP[LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM] = LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM, _POST_LIST_LAYOUT_TYP);
exports.POST_LIST_LAYOUT_TYPES = POST_LIST_LAYOUT_TYPES;

var LAYOUT_TYPES = _objectSpread(_objectSpread({}, FEED_LAYOUT_TYPES), POST_LIST_LAYOUT_TYPES);

exports.LAYOUT_TYPES = LAYOUT_TYPES;

var getLayoutTypeById = function getLayoutTypeById(layoutId) {
  return LAYOUT_TYPES[layoutId];
};

exports.getLayoutTypeById = getLayoutTypeById;
var LAYOUT_TYPES_MOBILE = (_LAYOUT_TYPES_MOBILE = {}, _LAYOUT_TYPES_MOBILE[LAYOUT_ONE_COLUMN_MOBILE] = LAYOUT_NAME_ONE_COLUMN_MOBILE, _LAYOUT_TYPES_MOBILE[LAYOUT_SIDE_BY_SIDE_MOBILE] = LAYOUT_NAME_SIDE_BY_SIDE_MOBILE, _LAYOUT_TYPES_MOBILE[LAYOUT_TEXT_ON_IMAGE_MOBILE] = LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE, _LAYOUT_TYPES_MOBILE);
exports.LAYOUT_TYPES_MOBILE = LAYOUT_TYPES_MOBILE;
var OTHER_LAYOUT_TYPES = (_OTHER_LAYOUT_TYPES = {}, _OTHER_LAYOUT_TYPES[LAYOUT_CARD_PROFILE] = LAYOUT_NAME_CARD_PROFILE, _OTHER_LAYOUT_TYPES[LAYOUT_MOBILE] = LAYOUT_NAME_MOBILE, _OTHER_LAYOUT_TYPES);
exports.OTHER_LAYOUT_TYPES = OTHER_LAYOUT_TYPES;

var getLayoutName = function getLayoutName(layoutType) {
  return LAYOUT_TYPES[layoutType] || LAYOUT_TYPES_MOBILE[layoutType] || OTHER_LAYOUT_TYPES[layoutType];
};

exports.getLayoutName = getLayoutName;

var isLayoutProGallery = function isLayoutProGallery(layoutType) {
  return [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_GRID, LAYOUT_PG_ONE_COLUMN].includes(Number(layoutType));
};

exports.isLayoutProGallery = isLayoutProGallery;

var isPGLayoutWithDescription = function isPGLayoutWithDescription(layoutType) {
  return [LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_GRID, LAYOUT_PG_ONE_COLUMN].includes(Number(layoutType));
};

exports.isPGLayoutWithDescription = isPGLayoutWithDescription;

var isLayoutNameOneOfProGallery = function isLayoutNameOneOfProGallery(layoutName) {
  return [LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_NAME_PG_CARD_MEDIUM, LAYOUT_NAME_PG_SIDE_BY_SIDE, LAYOUT_NAME_PG_GRID, LAYOUT_NAME_PG_ONE_COLUMN].includes(layoutName);
};

exports.isLayoutNameOneOfProGallery = isLayoutNameOneOfProGallery;

var isLayoutOneColumn = function isLayoutOneColumn(layoutType) {
  return Number(layoutType) === LAYOUT_CARD_LARGE;
};

var isLayoutPGOneColumn = function isLayoutPGOneColumn(layoutType) {
  return Number(layoutType) === LAYOUT_PG_ONE_COLUMN;
};

exports.isLayoutPGOneColumn = isLayoutPGOneColumn;

var isLayoutPGGrid = function isLayoutPGGrid(layoutType) {
  return Number(layoutType) === LAYOUT_PG_GRID;
};

exports.isLayoutPGGrid = isLayoutPGGrid;

var isLayoutPGSideBySide = function isLayoutPGSideBySide(layoutType) {
  return Number(layoutType) === LAYOUT_PG_SIDE_BY_SIDE;
};

exports.isLayoutPGSideBySide = isLayoutPGSideBySide;

var isLayoutPGCardMedium = function isLayoutPGCardMedium(layoutType) {
  return Number(layoutType) === LAYOUT_PG_CARD_MEDIUM;
};

exports.isLayoutPGCardMedium = isLayoutPGCardMedium;

var isLayoutPGWithContentHeight = function isLayoutPGWithContentHeight(layoutType) {
  return (0, _lodash.includes)([LAYOUT_PG_GRID, LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_ONE_COLUMN, LAYOUT_SLIDER, LAYOUT_LIST], Number(layoutType));
};

exports.isLayoutPGWithContentHeight = isLayoutPGWithContentHeight;

var isLayoutGrid = function isLayoutGrid(layoutType) {
  return Number(layoutType) === LAYOUT_GRID;
};

exports.isLayoutGrid = isLayoutGrid;

var isLayoutFullPost = function isLayoutFullPost(layoutType) {
  return Number(layoutType) === LAYOUT_FULL_POST;
};

exports.isLayoutFullPost = isLayoutFullPost;

var isLayoutTextOnImage = function isLayoutTextOnImage(layoutType) {
  return (0, _lodash.includes)([LAYOUT_TEXT_ON_IMAGE_SMALL, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_TEXT_ON_IMAGE_MOBILE, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM], Number(layoutType));
};

exports.isLayoutTextOnImage = isLayoutTextOnImage;

var isLayoutSlider = function isLayoutSlider(layoutType) {
  return Number(layoutType) === LAYOUT_SLIDER;
};

exports.isLayoutSlider = isLayoutSlider;

var isLayoutList = function isLayoutList(layoutType) {
  return Number(layoutType) === LAYOUT_LIST;
};

exports.isLayoutList = isLayoutList;

var isLayoutMobile = function isLayoutMobile(layoutType) {
  return (0, _lodash.includes)([LAYOUT_MOBILE, LAYOUT_ONE_COLUMN_MOBILE, LAYOUT_SIDE_BY_SIDE_MOBILE], Number(layoutType));
};

exports.isLayoutMobile = isLayoutMobile;

var isLayoutNameMobile = function isLayoutNameMobile(layoutName) {
  return (0, _lodash.includes)(MOBILE_LAYOUT_NAMES, layoutName);
};

exports.isLayoutNameMobile = isLayoutNameMobile;

var isLayoutNamePGSideBySide = function isLayoutNamePGSideBySide(layoutName) {
  return layoutName === LAYOUT_NAME_PG_SIDE_BY_SIDE;
};

exports.isLayoutNamePGSideBySide = isLayoutNamePGSideBySide;

var isLayoutNamePGOneColumn = function isLayoutNamePGOneColumn(layoutName) {
  return layoutName === LAYOUT_NAME_PG_ONE_COLUMN;
};

exports.isLayoutNamePGOneColumn = isLayoutNamePGOneColumn;

var isLayoutNameGrid = function isLayoutNameGrid(layoutName) {
  return layoutName === LAYOUT_NAME_GRID;
};

exports.isLayoutNameGrid = isLayoutNameGrid;

var isLayoutNameSlider = function isLayoutNameSlider(layoutName) {
  return layoutName === LAYOUT_NAME_SLIDER;
};

exports.isLayoutNameSlider = isLayoutNameSlider;

var isLayoutNameList = function isLayoutNameList(layoutName) {
  return layoutName === LAYOUT_NAME_LIST;
};

exports.isLayoutNameList = isLayoutNameList;

var isLayoutNameTextOnImage = function isLayoutNameTextOnImage(layoutName) {
  return (0, _lodash.includes)([LAYOUT_NAME_TEXT_ON_IMAGE_SMALL, LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM, LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE, LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM], layoutName);
};

exports.isLayoutNameTextOnImage = isLayoutNameTextOnImage;
var SUPPORTS_MULTIPLE_PAGES_PAGINATION = [LAYOUT_CARD_LARGE, LAYOUT_FULL_POST, LAYOUT_GRID, LAYOUT_MOBILE, LAYOUT_SIDE_BY_SIDE, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_TEXT_ON_IMAGE_SMALL, LAYOUT_ONE_COLUMN_MOBILE, LAYOUT_SIDE_BY_SIDE_MOBILE, LAYOUT_TEXT_ON_IMAGE_MOBILE, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_GRID, LAYOUT_PG_ONE_COLUMN];

var isMultiplePagesSupported = function isMultiplePagesSupported(layoutType) {
  return (0, _lodash.includes)(SUPPORTS_MULTIPLE_PAGES_PAGINATION, layoutType);
};

exports.isMultiplePagesSupported = isMultiplePagesSupported;

var isAuthorImageSupported = function isAuthorImageSupported(layoutId) {
  if ([LAYOUT_TEXT_ON_IMAGE_SMALL, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM].includes(layoutId)) {
    return false;
  }

  return true;
};

exports.isAuthorImageSupported = isAuthorImageSupported;
var SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT = 0;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT = SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT;
var SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT = 1;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT = SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT;
var SIDE_BY_SIDE_LAYOUT_IMAGE_NONE = 2;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_NONE = SIDE_BY_SIDE_LAYOUT_IMAGE_NONE;